<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Gerki pridelovalca</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
      <div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezonePisanje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            /> 
              <pridelovalec :pridelovalec="pridelovalec">
          </pridelovalec>
          </div>
        </div>
      
    <div class="uporabnik-spacer" style="margin-top:2rem"></div>
    <div class="grid-wrapper">
    <Grid  
                       auto-bind=false
                        :sortable="sortable"
                        :filterable="filterable"
                        :detail="'gerkDetailRowTemplate'"
                       
                        :data-items="gridData"
                        :skip="skip"
                        :take="take" 
                        :sort="sort" 
                        
                      
                        :filter="filter" 
                        :columns="columns"
                       
                           @datastatechange="dataStateChange"
                        :expand-field="'expanded'"
                        @expandchange="expandChange"
                      
                        :row-render="rowRenderFunction"
                        
                        
                        

                         
                        
                                               >
                 
                            <template v-slot:gerkDetailRowTemplate="{props}">
                        <gerkDetailRow :data-item="props.dataItem" :sezona="dataSezona"  />
                        </template>

                          <template v-slot:gerkStatusCellslot="{props}">
                  <gerkStatusCell :data-item="props.dataItem"/>

                    </template>

                     <template v-slot:gerkViewLink="{props}">
                        <gerkViewLink :data-item="props.dataItem"/>
                        </template>
                        <toolbar>
                             
                        <div class="km-widget km-buttongroup k-widget k-button-group">
                        <!--<button title="Dodaj"
                                class="k-button k-primary"
                                @click='insert'>
                                Dodaj
                        </button>
                        --> 

                         <button :disabled="editDisabled"
                                title="Shrani Gerke"
                                class="k-button k-primary"
                                @click="shraniGerke"
                            >
                                Shrani
                            </button>
                        <button 
                                title="Export to Excel"
                                class="k-button k-primary"
                                @click="exportExcel"
                            >
                                Izvozi v Excel
                            </button>
                        <!--
                        <button
                                title="Obrazec za površine"
                                class="k-button k-primary"
                                @click="kontrolniList"
                            >
                                Obrazec za površine
                            </button>
                          --><button class="k-button k-primary"  title="Nazaj" @click="nazaj" >Nazaj</button>
                        </div>
                         
                            
                        </toolbar>
                    </Grid>
                    <div class="shema-loader" v-if="loading"><font-awesome-icon icon="circle-notch" spin="spin"/></div>
                    </div>
                    </div>
    </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
//import '@progress/kendo-ui' // This will import the entire Kendo UI library

import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
import kulture from './support/kulture-data';
import { Grid, GridToolbar } from '@progress/kendo-vue-grid';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import { saveExcel } from '@progress/kendo-vue-excel-export';
import PridelovalecKratko from './support/PridelovalecKratko';
import GerkViewLink from './support/GerkViewLink';
import GerkDetailRow from './support/GerkDetailRow';
import GerkStatusCell from './support/GerkStatusCell';

import { process,orderBy } from '@progress/kendo-data-query';

/*
0-> nov
1-> zbrisan iz rkg
2-> spremenjen (v rkg ali na zbirni vlogi)
3-> shranjen
// posebej info, če je na zbirni vlogi

*/




export default {
  components:{
      'pridelovalec':PridelovalecKratko,
      'dropdownlist': DropDownList,
      'toolbar': GridToolbar,
      'Grid': Grid,
      'gerkViewLink': GerkViewLink,
      'gerkDetailRow': GerkDetailRow,
      'gerkStatusCell': GerkStatusCell
  },
  props:['sezona','pridelovalecid'],
    data () {
        return {
            //defaultItemSezona: { sezona: 'Izberi sezono...'},
            dataSezona:this.sezona,
         
         
           // girdDataApi:null,
            //gridData:null,


            filter: null,
            editID: null,
            skip: 0,
            take: 50,
            sortable: false,
            filterable: false,
            groupable: false,
            
            expandedItems: [],
            dataResult: [],
         
            sort: [
              
                { field: 'blokid', dir: 'asc' }
            ],
            columns: [
          
                { field: "blokid", title:"BLOKID",width: "150px",sortable:true},
                { field: "gerkpid", title:"GERKPID", footerCell: this.nogaStGerkov,width: "150px",sortable:true},
                { field: "povrsina", title:"Površina",type: "number", footerCell: this.nogaVsotaPovrsin,filterable:false,width: "80px",type:"number",format:"{0:n4}"},
                { field: "raba", title:"Raba",type: "string"},
                { field: "status", title:"Status", cell:'gerkStatusCellslot',filterable:false,width: "180px"},
                { field: "gerkpid", title:"Prikaz", cell:'gerkViewLink',filterable:false,width: "50px",webonly:true},
            ],
          

           

        }
    },
    created () {
      this.dataSezona={sezona:this.sezona};
    this.naloziPodatke();

    },
    computed: {
          ...mapState({gridData(state) {
          return state.gerk.gerk;// orderBy(state.gerk.gerk, this.sort);
        }}),
           editDisabled(){
          return (this.pridelovalec.pisanje==0)
        },
        //...mapState('gerk', ['gerk']),
        ...mapState('pridelava', ['pridelovalec']) ,  
        ...mapState('users', ['sezonePisanje']),        
    
           },
   
    methods: {

        ...mapActions('gerk', ['load','save']),
         ...mapActions('pridelava', ['loadIdPoSezoni','loadOne']),

         naloziPodatke(){

            this.load({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid});
            this.loadOne({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid});
    
         },
        
        nogaStGerkov: function (h, emptyElement , props, listeners ) {
          if(this.gridData)
            return h('span', {}, ['Število gerkov: ' + this.gridData.length]);
        },
        nogaVsotaPovrsin: function (h, emptyElement , props, listeners ) {
          if(this.gridData)
            return h('span', {}, ['Vsota površin: ' + this.gridData.reduce((acc, current) => acc+=current.povrsina, 0).toFixed(2)+ ' ha']);
        },
    

        
         rowRenderFunction: function (h, trElement , defaultSlots, props ) {
            console.log(trElement);
            console.log(props.dataItem);
            /*
0-> nov
1-> zbrisan iz rkg
2-> spremenjen (v rkg ali na zbirni vlogi)
3-> shranjen
// posebej info, če je na zbirni vlogi
*/
            if(props.dataItem.stanje==0)
            trElement.data.class+=" gerk_nov";
            else if(props.dataItem.stanje==1)
            trElement.data.class+=" gerk_zbrisan";
            else if(props.dataItem.stanje==2)
            trElement.data.class+=" gerk_spremenjen";


                return trElement;
            },
       
        sezonaChange(event) {

           const sezona = event.value;
           
            this.loadIdPoSezoni({sezona:sezona.sezona,pridelovalecid:this.pridelovalecid}).then(pridelovalec=>{
              this.pridelovalecid=pridelovalec.id;
              this.dataSezona=sezona;
             this.$router.push({ name: 'gerk', params: {sezona:sezona.sezona,pridelovalecid:pridelovalec.id} });

             this.naloziPodatke();
              });

            
        },

       
        dataStateChange (event) {
            console.log("change sort!!!");
            this.sort=event.sort;
            this.gerk

        },
        expandChange (event) {
            //const isExpanded =
              //  event.dataItem.expanded === undefined ?
                //    event.dataItem.aggregates : event.dataItem.expanded;
            //Vue.set(event.dataItem, 'expanded', !isExpanded);
             Vue.set(event.dataItem, event.target.$props.expandField, !event.dataItem.expanded);
            console.log(event);
        },
        exportExcel () {
            this.saveExcel({
                data: this.gridData,
                fileName: this.pridelovalecid+"_GERKI",
                columns: [...this.columns, { field: "stanje", title:"stanje",width: "150px",sortable:true}]
            });
        },
        shraniGerke () {
          //console.log(this.dataResult);
         
              this.save();
           //    this.load({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid});

                     
        },
        kontrolniList () {
          console.log("PUSSHED");

        
                this.$router.push({ name: 'kontrolniList', params: {gerki:this.gridData.map(g=>{g.povrsina=parseFloat(g.povrsina).toFixed(2);return g}),vsotaPovrsin:(this.gridData.reduce((a,c)=>{return a+parseFloat(c.povrsina);},0.0)).toFixed(2),pridelovalec:this.pridelovalec} })

                     
        },
        
      
      
        /*
        changeStatus: function (e) {
            console.log("Gerk change!!!");
            console.log(e.dataItem);
          //  Vue.set(e.dataItem, 'inEdit', true);
        },
*/
    
    }
};
</script>

